import { Component, signal } from '@angular/core';
import { Home } from "./modules/home/home";
import { RouterOutlet } from '@angular/router';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('youprice-vitrineV3');
}
